import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { ROUTE_PATHS } from '@/lib/index';

export default function AdminAccess() {
  const navigate = useNavigate();

  useEffect(() => {
    sessionStorage.setItem('admin_bypass', 'cyf24_admin_2026');
    try {
      localStorage.setItem('admin_bypass', 'cyf24_admin_2026');
    } catch {}
    const timer = setTimeout(() => {
      navigate(ROUTE_PATHS.ADMIN, { replace: true });
    }, 800);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center space-y-4">
        <div className="relative inline-block">
          <Shield className="w-16 h-16 text-gold mx-auto animate-pulse" />
        </div>
        <p className="text-lg font-semibold text-foreground">Aktywacja dostępu administratora...</p>
        <p className="text-sm text-muted-foreground">Przekierowanie do panelu administratora</p>
      </div>
    </div>
  );
}